import { Add, School } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { useEffect, useState } from "react";
import {
  CustomDatagrid,
  CustomRowBase,
} from "../../components/datagrid/CustomDatagrid";
import errorHandler from "../../components/core/store/errorHandler";
import axios from "axios";
import { headers } from "../../components/core/store/localStorage";
import Colors from "../../components/constants/Colors";
import { ValidationDialog } from "../../components/modals/RequiredModal";
import { FilterDisciplinas } from "../../components/filter/FilterDisciplinas";

const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

export const Disciplinas = () => {
  const [registerDisciplina, setRegisterDisciplina] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [codDisciplina, setCodDisciplina] = useState("");
  const [descricao, setDescricao] = useState("");
  const [notFound, setNotFound] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0); // DataGrid é 0-based
  const [rowCount, setRowCount] = useState(0);
  const [titleLoading, setTitleLoading] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [valModalOpen, setValModalOpen] = useState(false);
  const [valErrors, setValErrors] = useState<string[]>([]);
  const [searchCodDisciplina, setSearchCodDisciplina] = useState("");

  useEffect(() => {
    getDisciplinas();
    if (API_URL === null) window.location.href = "/";
  }, []);

  useEffect(() => {
    getDisciplinas();
  }, [page]);

  const searchDisciplinas = async () => {
    setTitleLoading("Buscando turmas...");
    setNotFound(false);
    setLoading(true);
    setTrigger(false);
    try {
      await getDisciplinas(); // agora de fato espera
      if (rows.length === 0) {
        setTrigger(false);
        setNotFound(true);
      } else {
        setTrigger(true);
        setNotFound(false);
      }
    } finally {
      setLoading(false); // desliga sempre (sucesso/erro)
    }
  };

  const getDisciplinas = async () => {
    setLoading(true);
    setTitleLoading("Buscando eventos...");
    try {
      const apiPage = page + 1;
      let url = `${API_URL}/disciplina?page=${apiPage}`;

      if (searchCodDisciplina) url += `&filtro=${searchCodDisciplina}`;
      //   if (searchDescricao) url += `&descricao=${searchDescricao}`;

      const response = await axios.get(url, headers());

      const { disciplinas, totalPages } = response.data;

      if (!disciplinas || disciplinas.length === 0) {
        setTrigger(false);
        return;
      }

      if (disciplinas) setTrigger(true);
      setRows(disciplinas);
      setRowCount((totalPages ?? 0) * PAGE_SIZE);
    } catch (err: any) {
      console.error("Erro ao buscar eventos:", {
        message: err.message,
        response: err.response?.data,
        stack: err.stack,
      });
      setTrigger(false);
      setNotFound(true);
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setTrigger(true);
    setRegisterDisciplina(false);
    setCodDisciplina("");
    setDescricao("");
    setSearchCodDisciplina("");
  };

  const iniciarCadastro = () => {
    setSearchCodDisciplina("");
    setTrigger(false);
    setRegisterDisciplina(true);
    setNotFound(false);
    setIsEditing(false);
  };

  const cadastrarDisciplina = async () => {
    try {
      setIsWaiting(true);

      const errors: string[] = [];

      if (!codDisciplina || !codDisciplina.trim())
        errors.push("Informe o código do evento.");

      if (errors.length) {
        setValErrors(errors);
        setValModalOpen(true);
        setIsWaiting(false);
        return; // interrompe envio
      }

      const payload = {
        id: codDisciplina,
        inativo: false,
        descricao,
      };

      console.log(`${JSON.stringify(payload, null, 2)}`);
      await axios.post(`${API_URL}/disciplina`, payload, headers());
    } catch (err) {
      console.log(err);
    }

    getDisciplinas();
    setCodDisciplina("");
    setDescricao("");
    setIsWaiting(false);
    setRegisterDisciplina(false);
  };

  const handleEdit = (r: CustomRowBase) => {
    setIsEditing(true);
    setCodDisciplina(String(r.id ?? ""));
    setDescricao(r.descricao ?? "");
    setTrigger(false);
    setRegisterDisciplina(true);
  };

  return (
    <>
      <Grid wrap="wrap">
        <Grid
          size={{ xs: 6, sm: 7, md: 8, xl: 10 }}
          style={{
            marginTop: "-1.6rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 className={css(styles.pageTitle)} style={{ marginRight: "4px" }}>
            {registerDisciplina ? "Cadastrar disciplina" : "Disciplinas"}
          </h3>

          <div style={{ display: "flex", gap: "15px" }}>
            {registerDisciplina ? (
              <button className={css(styles.topBtn)} onClick={handleBack}>
                Voltar
              </button>
            ) : (
              <Tooltip title={"Adicionar nova disciplina"}>
                <button
                  onClick={iniciarCadastro}
                  className={css(styles.topBtn)}
                >
                  <Add />
                </button>
              </Tooltip>
            )}
          </div>
        </Grid>
      </Grid>

      <hr
        style={{
          color: "#eee",
          marginTop: "-0.55rem",
          marginBottom: "1rem",
        }}
      />

      {!registerDisciplina ? (
        <FilterDisciplinas
          searchDisciplinas={searchDisciplinas}
          searchCodDisciplina={searchCodDisciplina}
          setSearchCodDisciplina={setSearchCodDisciplina}
        />
      ) : null}

      {trigger ? (
        <Box>
          <Box sx={{ width: "100%", display: "grid", gap: 2, marginTop: 2 }}>
            <CustomDatagrid
              rows={rows}
              visibleColumns={["id", "descricao", "actions"]}
              extraColumns={[
                {
                  field: "id",
                  headerName: "Código",
                  minWidth: 100,
                  flex: 1,
                },
              ]}
              actions={["edit"]}
              onEdit={(r) => handleEdit(r)}
              // 🔽 paginação no servidor
              loading={loading}
              paginationMode="server"
              paginationModel={{ page, pageSize: PAGE_SIZE }}
              onPaginationModelChange={(model) => {
                if (model.page !== page) setPage(model.page);
                // ignora mudanças de pageSize (API fixa em 30)
              }}
              rowCount={rowCount}
            />
          </Box>
        </Box>
      ) : null}

      {registerDisciplina ? (
        <Box sx={{ width: "100%", display: "grid", gap: 2, marginTop: 2 }}>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <School fontSize={"inherit"} /> Informações da Disciplina
                  </Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    required
                    placeholder="Código da Disciplina"
                    value={codDisciplina}
                    type="text"
                    onChange={(ev) => {
                      setCodDisciplina(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Código da Disciplina"
                    disabled={isEditing}
                    sx={{
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: (theme) => theme.palette.text.disabled,
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: (theme) =>
                          theme.palette.action.disabledBackground,
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: (theme) => theme.palette.action.disabled,
                        },
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: (theme) =>
                          theme.palette.text.disabled,
                      },
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 8 }}>
                  <TextField
                    fullWidth
                    placeholder="Descrição"
                    value={descricao}
                    type="text"
                    onChange={(ev) => {
                      setDescricao(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Descrição"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Grid size={{ xs: 12 }} textAlign={"center"}>
            <Button
              variant="outlined"
              color="primary"
              sx={{
                "&:disabled": {
                  color: Colors.muiPrimary,
                },
              }}
              // disabled={isWaiting}
              onClick={() => cadastrarDisciplina()}
            >
              {isWaiting ? <CircularProgress size={20} /> : "Confirmar"}
            </Button>
          </Grid>
        </Box>
      ) : null}

      {loading ? (
        <Box
          width={"100%"}
          height={"45vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            size={{ xs: 12, md: 12 }}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"#eceff9ff"}
            borderRadius={5}
            padding={5}
            color={Colors.noResultFont}
          >
            <div
              style={{
                marginTop: "-0.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="primary" />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  color: "#4b4b4b",
                  fontSize: 14,
                  marginBottom: "-1rem",
                }}
              >
                {titleLoading}
              </p>
            </div>
          </Grid>
        </Box>
      ) : null}

      {notFound ? (
        <Box
          width={"100%"}
          height={"45vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            size={{ xs: 12, md: 12 }}
            height={{ md: "20%", xs: "50%" }}
            display={"inline-flex"}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"lightyellow"}
            borderRadius={5}
            padding={5}
            color={Colors.noResultFont}
          >
            <p
              style={{
                color: "#4b4b4b",
                fontSize: 14,
              }}
            >
              Sua pesquisa não retornou nenhum resultado.
            </p>
          </Grid>
        </Box>
      ) : null}

      <ValidationDialog
        open={valModalOpen}
        onClose={() => setValModalOpen(false)}
        errors={valErrors}
      />
    </>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
  },
  input: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent",
      borderColor: "#669966",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent",
      borderColor: "#669966",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
  },
  erro: {
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
  topBtn: {
    cursor: "pointer",
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#186ad6ff",
      backgroundColor: "transparent",
      borderColor: "#186ad6ff",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
});
